import {  ALL_INFO_RETIREMENT_STEPS, ALL_INFO_STEPS, APP_RETIREMENT_URLS, APP_URLS, FAMILY_SITUATION_MARIE_CODE, FAMILY_SITUATION_PACS_CODE, PROPOSITION_DOC_TYPES } from '../const/AppConst';
import {
    CartCheckStepInfo,
    IAdditionalData,
    IBeneficiaryAdditionReq,
    IChangedContact, IConsent, IContactDetail, IExtractedRibInfo, IExtractedSecurityInfo,
    IInfoStep, IPropositionDetails, IRERequestDataOffers, ISimulateOffers, IUploadedDoc, IUploadedDocument,
} from "../context/model";
import { IDocumentType, IGarantiePrices, IUpdatedProposition, relationType } from '../context/model/index';
import { collectOffers, collectOffersRetired } from '../services/CustomerApiService';
import { getAge, getDayDifferent } from './utils';

export const isPropositionAfterSignature = (proposition: IPropositionDetails): boolean => {
    const statusList: number[] = [
        284500020, // En attente validation RH
        284500008, // Complété
        284500009, // Validé
        284500010, // Invalide
        284500018, // En Attente AIA
        284500011, // Erreur de mise en GED
        284500012, // Erreur de souscription
        284500017, // Souscription finalisée
        7,         // Réviser
        6,         // Annulé
    ];

    return proposition && statusList.indexOf(proposition.statusCode) !== -1
}

export const isPropositionInDraft = (proposition: IPropositionDetails): boolean => {
    return proposition && proposition.stateCode === 0;
}

export const isConfirmedContactProposition = (proposition: IPropositionDetails): boolean => {
    return proposition && proposition.stateCode === 0 && proposition.mainStep === "LOCK_PERSO_INFO";
}

export const isPropositionInLock = (proposition: IPropositionDetails): boolean => {
    return proposition && proposition.stateCode === 1;
}

export const isCompletedProposition = (proposition: IPropositionDetails): boolean => {
    return proposition && proposition.stateCode === 1
    && (proposition.statusCode === 3 || proposition.statusCode === 284500007 || proposition.statusCode === 284500008);
}

export const isWaitingClient = (proposition: IPropositionDetails): boolean => {
    return proposition && proposition.stateCode === 1 && proposition.statusCode === 284500019;
}

export const isDoneProposition = (proposition: IPropositionDetails): boolean => {
    return proposition.stateCode === 1 
    && (proposition.statusCode === 284500009 || proposition.statusCode === 284500010 || proposition.statusCode === 284500011
        || proposition.statusCode === 284500012 || proposition.statusCode === 284500018  || proposition.statusCode === 284500019);
}

export const isClosedProposition = (proposition: IPropositionDetails): boolean => {
    return proposition.stateCode === 1
    && (proposition.statusCode === 284500017);
}


export const hasUpdateContactOfProposition = (currentContact: IContactDetail, updatedContact: IChangedContact): boolean => {
    return currentContact.birthPlace?.toUpperCase() !== updatedContact.birthPlace?.toUpperCase()
    || currentContact.email !== updatedContact.email
    || currentContact.phoneNumber !== updatedContact.phoneNumber
    || currentContact.familySituationCode?.toString() !== updatedContact.familySituationCode;
}

export const hasUpdateConsentOfProposition = (currentConsent: IConsent, updatedConsent: IConsent): boolean => {
    return currentConsent.commercialEmailAccept !== updatedConsent.commercialEmailAccept
    || currentConsent.commercialSmsAccept !== updatedConsent.commercialSmsAccept 
    || currentConsent.commercialTelephoneAccept !== updatedConsent.commercialTelephoneAccept    
    || currentConsent.commercialPartnerAccept !== updatedConsent.commercialPartnerAccept

}

export const filterSecuDocs = (proposition: IPropositionDetails): IUploadedDocument<IExtractedSecurityInfo>[] => {
    let uploadedSecuDocs = [] as IUploadedDocument<IExtractedSecurityInfo>[];
    if(proposition.documents?.length > 0) {
        const docs = proposition.documents.filter(doc => doc.documentCategory === 'social-security');

        if(docs) {
        uploadedSecuDocs = docs.map(doc => {
           return {
            id: doc.documentId,
            fileName: doc.documentFileName,
            extractedData: {},
            name: doc.name
           } as IUploadedDocument<IExtractedSecurityInfo>;
        })
       }
    };

    return uploadedSecuDocs;
}

export const filterRibDoc = (proposition: IPropositionDetails): IUploadedDocument<IExtractedRibInfo> => {
    let uploadedRibDoc = {} as IUploadedDocument<IExtractedRibInfo>;
    if(proposition.documents?.length > 0) {
        const doc = proposition.documents.find(doc => doc.documentTypeCode === 'RIB');
        if(doc) {
            uploadedRibDoc = {
                id: doc.documentId,
                fileName: doc.documentFileName,
                extractedData: {},
                name: doc.name
               } as IUploadedDocument<IExtractedRibInfo>;
            
        }
    };

    return uploadedRibDoc;
}

export const filterFamilyDocs = (proposition: IPropositionDetails): IUploadedDoc[] => {
    let uploadedFamilyDocs = [] as IUploadedDoc[];
    if(proposition.documents?.length > 0) {
        const docs = proposition.documents.filter(doc => doc.documentCategory === 'family');
       if(docs) {
        uploadedFamilyDocs = docs.map(doc => {
           return {
            id: doc.documentId,
            fileName: doc.documentFileName,
            extractedData: {},
            name: doc.name
           } as IUploadedDoc;
        })
       }
    };

    return uploadedFamilyDocs;
}

export const filterSignDocs = (proposition: IPropositionDetails): IUploadedDoc[] => {
    let uploadedDocs = [] as IUploadedDoc[];
    if(proposition.documents?.length > 0) {
        const docs = proposition.documents.filter(doc => doc.documentCategory === 'contract');
       if(docs) {
        uploadedDocs = docs.map(doc => {
           return {
            id: doc.documentId,
            fileName: doc.documentFileName,
            extractedData: {},
            name: doc.name
           } as IUploadedDoc;
        })
       }
    };

    return uploadedDocs;
}

export const hasLockMode = (stateCode: number = 0, category: string) : boolean => {
    const isCategory = category === "DEMANDE" || category === "PERSONAL" || category === "BENEFICIARY" || category === "GUARANTY";
    const isStateCode = stateCode === 1
    return isCategory && isStateCode;
}
export const isValidatedProposition = (proposition?: IPropositionDetails): boolean => {
    if(proposition &&
    (proposition.statusCode === 284500007 || 
    proposition.statusCode === 284500008 || 
    proposition.statusCode === 284500009) && 
    proposition.documents.filter(
        doc => doc.status === 'Invalide' || 
        doc.status === 'Reçu' || 
        doc.status === 'Remis').length === 0 ) {
        return true;
    } else {
        return false;
    }
}

export const displaySecuNumber = (nir: string | undefined, nirKey: string | undefined) : string => {
    let secuNumber = '';
    const nirKeyVal =  nirKey??'';
    if(!nir) {
        secuNumber += nirKeyVal;
        return secuNumber;
    } else if(nir.length !== 13) {
        return nir + " " + nirKeyVal;
    }
    
    const nirArray = nir.split('');

    return nirArray[0] + ' ' + nirArray[1] + nirArray[2] + ' ' + nirArray[3] + nirArray[4] + ' ' + nirArray[5] + nirArray[6] 
        + ' ' + nirArray[7] + nirArray[8]+ nirArray[9] + ' ' + nirArray[10] + nirArray[11]+ nirArray[12]
         + ' ' + nirKeyVal;
}

export const getRequireFamilyDocumentTypes = (updatedProposition: IUpdatedProposition, additionalData: IAdditionalData | null) : IDocumentType[] => {
    const requiredFamilyDocTypes = [] as IDocumentType[];

    if (!additionalData?.hasChild && !additionalData?.hasPartner) {
        return requiredFamilyDocTypes;
    }
    if (updatedProposition.familySituationCode === FAMILY_SITUATION_PACS_CODE) {
        requiredFamilyDocTypes.push(PROPOSITION_DOC_TYPES.find(doc => doc.code === 'PACS')!);
    } else if (updatedProposition.familySituationCode === FAMILY_SITUATION_MARIE_CODE 
        || updatedProposition.beneficiaries?.find(b => b.relationType === relationType.CHILD)) {
        requiredFamilyDocTypes.push(PROPOSITION_DOC_TYPES.find(doc => doc.code === 'FAMILY_RECORD_BOOK')!);
    } else {
        requiredFamilyDocTypes.push(PROPOSITION_DOC_TYPES.find(doc => doc.code === 'COMMON_LIVE_PROOF')!);
        requiredFamilyDocTypes.push(PROPOSITION_DOC_TYPES.find(doc => doc.code === 'COMMON_ADDRESS_PROOF')!);
    }

    if(updatedProposition.beneficiaries?.find(b => b.relationType === relationType.CHILD && getAge(b.contact.birthDate) >=21)) {
        requiredFamilyDocTypes.push(PROPOSITION_DOC_TYPES.find(doc => doc.code === 'SCHOOL_CERTIFICATE')!);
    }

    if(updatedProposition.beneficiaries?.find(b => b.relationType === relationType.CHILD && updatedProposition.beneficiaries?.find(el => el.contact.hasHandicap))) {
        const handicapChildren = updatedProposition.beneficiaries.filter(el => el.contact.hasHandicap);
        let result = [] as IDocumentType[];
        handicapChildren.forEach(() => {
            result.push(PROPOSITION_DOC_TYPES.find(doc => doc.code === 'CHILD_HANDICAP_PROOF')!);
        })

        requiredFamilyDocTypes.push(...result.map((item, i) => ({
            code: item.code,
            fileName: `${item.fileName}_${i}`,
            label: `${item.label}${handicapChildren.length > 1 ? " pour enfant " +(i+1) : ""}`,
            category: item.category,
            hasRequired: item.hasRequired,
            displayLabel: item.displayLabel
        })));
    }

    return requiredFamilyDocTypes;
}
export const getRequireREFamilyDocumentTypes = (additionData : IAdditionalData|null, familyCode: string): IDocumentType[]=> {
    let requiredFamilyDocTypes = [] as IDocumentType[];
    if(!additionData) return requiredFamilyDocTypes
    // have conjoint => check family situation
    if(additionData.hasPartner){
        if(familyCode === FAMILY_SITUATION_MARIE_CODE){
            requiredFamilyDocTypes.push(PROPOSITION_DOC_TYPES.find(doc => doc.code === 'FAMILY_RECORD_BOOK')!);
        } else if (familyCode === FAMILY_SITUATION_PACS_CODE) {
            requiredFamilyDocTypes.push(PROPOSITION_DOC_TYPES.find(doc => doc.code === 'PACS')!);
        } else  {
            requiredFamilyDocTypes.push(PROPOSITION_DOC_TYPES.find(doc => doc.code === 'COMMON_LIVE_PROOF')!);
            // requiredFamilyDocTypes.push(PROPOSITION_DOC_TYPES.find(doc => doc.code === 'COMMON_ADDRESS_PROOF')!);
        }
    }
    // have child/children =>
    if(additionData.hasChild){
        // check if requiredFamilyDocTypes has already FAMILY_RECORD_BOOK
        if(requiredFamilyDocTypes.findIndex(doc => doc.code === 'FAMILY_RECORD_BOOK') ===-1) {
            requiredFamilyDocTypes.push(PROPOSITION_DOC_TYPES.find(doc => doc.code === 'FAMILY_RECORD_BOOK')!);
        }
        // check if have child >25 =? school certificate
        // const childrenArray = updatedPropo.beneficiaries.filter(person => person.relationType === 'CHILD')
        if(additionData?.children?.findIndex(child=>getAge(child.birthDate) >=25) !== -1){
            requiredFamilyDocTypes.push(PROPOSITION_DOC_TYPES.find(doc => doc.code === 'SCHOOL_CERTIFICATE')!);
        }
        if((additionData?.children?.findIndex(child=>child.hasHandicap === true) !== -1)){
            requiredFamilyDocTypes.push(PROPOSITION_DOC_TYPES.find(doc => doc.code === 'CHILD_HANDICAP_PROOF')!);
        }

    }
    // set value FAMILY_RECORD_BOOK at first
    const hasFamilyRecordBook = requiredFamilyDocTypes?.findIndex(doc=> doc.code === 'FAMILY_RECORD_BOOK') !== -1;
    if(hasFamilyRecordBook){
        const filterArr =  requiredFamilyDocTypes.filter(doc=> doc.code !== 'FAMILY_RECORD_BOOK')
        requiredFamilyDocTypes =[PROPOSITION_DOC_TYPES.find(doc => doc.code === 'FAMILY_RECORD_BOOK')!, ...filterArr]
    }
        return requiredFamilyDocTypes
}
export const getStartPage = (proposition?: IPropositionDetails, lastStepPath?: string|null, stepCode?:string|null, isConseiller?: boolean): string => {
    // Draft
    if(isPropositionInDraft(proposition!)) {
        if(lastStepPath) {
            return lastStepPath;
        } else {
           return isConfirmedContactProposition(proposition!) ? APP_URLS.infoPersoRecapPage : APP_URLS.bienvenuePage;
        }
        
    } else if (isClosedProposition(proposition!)) {
        return APP_URLS.endPage;
    } else if (isDoneProposition(proposition!) && isConseiller && !stepCode) {
        return APP_URLS.postSignatureActionPage;
    } else {
        if(stepCode) {
            const stepPath = ALL_INFO_STEPS.find(step => step.code === stepCode)?.path;
            return stepPath??APP_URLS.recapPage;
        }
        return APP_URLS.recapPage;
    }
}

export const initUpdatedProposition = (proposition?: IPropositionDetails, lastStepPath?: string|null): string => {
    // Draft
    if(isPropositionInDraft(proposition!)) {
        return lastStepPath??APP_URLS.bienvenuePage;
    } else if (isClosedProposition(proposition!)) {
        return APP_URLS.endPage;
    } else {
        return APP_URLS.recapPage;
    }
}

export const hasUpdateBeneficiary = (currentBeneficiary: IBeneficiaryAdditionReq, updatedBeneficiary: IBeneficiaryAdditionReq): boolean => {
    return currentBeneficiary.relationType !== updatedBeneficiary.relationType || 
    currentBeneficiary.contact.alsaceMoselleRegime !== updatedBeneficiary.contact.alsaceMoselleRegime || 
    currentBeneficiary.contact.attachmentOrganization!== updatedBeneficiary.contact.attachmentOrganization || 
    currentBeneficiary.contact.birthDate !== updatedBeneficiary.contact.birthDate || 
    currentBeneficiary.contact.civilityCode?.toString() !== updatedBeneficiary.contact.civilityCode?.toString() || 
    currentBeneficiary.contact.contactId !== updatedBeneficiary.contact.contactId || 
    currentBeneficiary.contact.firstName !== updatedBeneficiary.contact.firstName || 
    currentBeneficiary.contact.lastName !== updatedBeneficiary.contact.lastName || 
    currentBeneficiary.contact.nir !== updatedBeneficiary.contact. nir || 
    currentBeneficiary.contact.nirKey !== updatedBeneficiary.contact.nirKey ||
    currentBeneficiary.contact.regimeCode !== updatedBeneficiary.contact.regimeCode
}

export const hasUpdatedStepCart = (proposition: IPropositionDetails, currentStep?: IInfoStep) : boolean => {
    const categoryStep =  currentStep?.category;
    const isCategory = categoryStep === "DEMANDE" || categoryStep === "PERSONAL" || categoryStep === "BENEFICIARY" || categoryStep === "RECAP" || categoryStep === "GUARANTY" || categoryStep === "INFO" || categoryStep === "BESOIN" || categoryStep === "SITUATION" || categoryStep === "SIGNATURE";
    return isPropositionInDraft(proposition) && isCategory;
}

export const calculCotisation = (garantieCode: string, beneficiaries?: IBeneficiaryAdditionReq[]): string => {


    const garantiePrice : IGarantiePrices = {
        conjointPrice: 66,
        childLess21Price: 30,
        childPlus21Price: 60,
        options: [ 
            {
                code: 'MIOM_OPT1',
                mpPrice: 3,
                conjointPrice: 6,
                childLess21Price: 3.6,
                childPlus21Price: 6
            },
            {
                code: 'MIOM_OPT2',
                mpPrice: 5,
                conjointPrice: 10,
                childLess21Price: 6,
                childPlus21Price: 10
            },
            {
                code: 'MIOM_ORPT1',
                mpPrice: 3,
                conjointPrice: 6,
                childLess21Price: 3.6,
                childPlus21Price: 6
            },
            {
                code: 'MIOM_ORPT2',
                mpPrice: 5,
                conjointPrice: 10,
                childLess21Price: 6,
                childPlus21Price: 10
            }
        ]
    };

    const optionPrice = garantiePrice.options.find(o => o.code === garantieCode);

    let total : number = optionPrice?optionPrice.mpPrice : 0;


    if(beneficiaries && beneficiaries.length > 0) {
        let countChildUnder21 = 0;
        beneficiaries.forEach(b => {
            if(b.relationType === relationType.CHILD) {
                const childAge = getAge(b.contact.birthDate);
                if(childAge >= 21) {
                    total += garantiePrice.childPlus21Price;
                    total += optionPrice?optionPrice.childPlus21Price : 0;
                } else if(childAge < 21) {
                    countChildUnder21++;                   
                    total += garantiePrice.childLess21Price;
                    total += optionPrice?optionPrice.childLess21Price : 0;
                }
            } else {
                total += garantiePrice.conjointPrice;
                total += optionPrice?optionPrice.conjointPrice : 0;
            }
        })
        // Calcul price 3 child < 21
        const numberChild = beneficiaries.filter(el => el.relationType === relationType.CHILD).length;
        if(numberChild >= 3 && countChildUnder21 > 0) {
            const countChildPlus21 = numberChild - countChildUnder21;
            if(countChildPlus21 >= 2) {
                total = total - garantiePrice.childLess21Price * countChildUnder21;
                total = total - (optionPrice?optionPrice.childLess21Price : 0) * countChildUnder21;
            } else if(countChildPlus21 === 1) {
                total = total - garantiePrice.childLess21Price * (countChildUnder21 - 1);
                total = total - (optionPrice?optionPrice.childLess21Price : 0) * (countChildUnder21 - 1);
            } else {
                total = total - garantiePrice.childLess21Price * (countChildUnder21 - 2);
                total = total - (optionPrice?optionPrice.childLess21Price : 0) * (countChildUnder21 - 2);
            }
        }
    }

    return new Intl.NumberFormat("fr-FR", {maximumFractionDigits: 2, minimumFractionDigits: 2, style: "currency", currency: "EUR", currencyDisplay: "symbol"}).format(total);
}

export const formatFrAmount = (amount: number) : string => {
    return new Intl.NumberFormat("fr-FR", {maximumFractionDigits: 2, minimumFractionDigits: 2, style: "currency", currency: "EUR", currencyDisplay: "symbol"}).format(amount);
}

export const displaySteps = (proposition: IPropositionDetails): IInfoStep[] => {
    let steps = [...ALL_INFO_STEPS].filter(step => step.category);
    if (!proposition?.configuration.hasSignature) {
        const index = steps.findIndex(step => step.path === APP_URLS.infoSignatureStep0Page);
        steps.splice(index, 1);
        const index1 = steps.findIndex(step => step.path === APP_URLS.infoSignatureStep1Page);
        steps.splice(index1, 1);
        const index2 = steps.findIndex(step => step.path === APP_URLS.infoSignatureStep2Page);
        steps.splice(index2, 1);
    };
    if (!proposition?.configuration.canBeAddedBeneficiaries) {
        const index = steps.findIndex(step => step.path === APP_URLS.infoBeneficiaryStep0Page);
        steps.splice(index, 1);
        const index1 = steps.findIndex(step => step.path === APP_URLS.infoBeneficiaryStep1Page);
        steps.splice(index1, 1);
        const index2 = steps.findIndex(step => step.path === APP_URLS.infoBeneficiaryStep2Page);
        steps.splice(index2, 1);
        const index3 = steps.findIndex(step => step.path === APP_URLS.familyDocumentsPage);
        steps.splice(index3, 1);
    };
    if (!proposition?.configuration.hasIdentityUploadStep) {
        const index = steps.findIndex(step => step.path === APP_URLS.infoPersoStep6Page);
        steps.splice(index, 1);
    };
    if (!proposition?.configuration.hasSalaryStep) {
      const index = steps.findIndex(step => step.path === APP_URLS.infoPersoStep7Page);
      steps.splice(index, 1);
    };
    
    if(proposition?.configuration.hasShowPriceAmount === false) {
        const index = steps.findIndex(step => step.path ===  APP_URLS.infoPersoStep0Page);
        steps.splice(index, 1);
    };

    if(!proposition?.configuration.hasPreviousInsuranceTermination || getDayDifferent(proposition?.effectiveDate) <= 32) {
        const index = steps.findIndex(step => step.path === APP_URLS.infoOldContractPage);
        steps.splice(index, 1);
    }
    
    if(!isDoneProposition(proposition) && !isClosedProposition(proposition)) {
      const index = steps.findIndex(step => step.path ===  APP_URLS.listInvalidDocumentPage);
      steps.splice(index, 1);
    };

    return steps;
}

export const firstDateOfMonth = (d: Date)=> {
    const first = new Date(d.getFullYear(), d.getMonth(), 1);
    const year = first.getFullYear();
    const month = String(first.getMonth() + 1).padStart(2, '0'); 
    const day = String(first.getDate()).padStart(2, '0');
 
  return `${year}-${month}-${day}`;
} 
export const disabledRESteps = (): IInfoStep[] => {
    const disableSteps =  [
        APP_RETIREMENT_URLS.infoIdentityDocPage, 
        APP_RETIREMENT_URLS.infoAddressPage, 
        APP_RETIREMENT_URLS.infoContactPage, 
        APP_RETIREMENT_URLS.infoOldContractPage, 
        APP_RETIREMENT_URLS.infoBankPage, 
        APP_RETIREMENT_URLS.infoAddressPage, 
        APP_RETIREMENT_URLS.infoAttestationROBeneficiaryPage, 
        APP_RETIREMENT_URLS.infoRetirementDocPage,
        APP_RETIREMENT_URLS.infoBeneficiaryPage, 
        APP_RETIREMENT_URLS.infoFamilyDocPage, 
        APP_RETIREMENT_URLS.infoIdentityDocPage, 
        APP_RETIREMENT_URLS.infoFamilyDocPage, 
        APP_RETIREMENT_URLS.infoLastEmployeeDocPage,
        APP_RETIREMENT_URLS.infoAttestationROPage,
        APP_RETIREMENT_URLS.infoIdentityPage
    ];
    let displayedSteps = [...ALL_INFO_RETIREMENT_STEPS].map(step => {
        if (disableSteps.indexOf(step.path) !== -1){
            return {...step, state: "INACTIVE" as IInfoStep['state']}
        } else return step
    })
    return displayedSteps
}

export const displayRetiredSteps = (cartInfo ?: CartCheckStepInfo): IInfoStep[] => {
    let steps = [...ALL_INFO_RETIREMENT_STEPS];
    
    // check if CNI is required
    if (!cartInfo?.requiredCNI) {
        const index = steps.findIndex(step => step.code === "INFO_IDENTITY_DOC");
        steps.splice(index, 1);
    };

    // Check if there is beneficiary
    if (!(cartInfo?.hasChild || cartInfo?.hasPartner)){
        const filteredPages = ["INFO_ATTES_BENE", "INFO_BENE", "INFO_FAMILY_DOC"];
        for(let i = 0; i < filteredPages.length; i++){
            const index = steps.findIndex(step => step.code === filteredPages[i]);
            steps.splice(index, 1);
        }
    };

    // Check if RIA is chosen
    if(!cartInfo?.hasOldMutual){
        const index = steps.findIndex(step => step.code === "INFO_OLD_CONTRACT");
        steps.splice(index, 1);
    }

    return steps;
}

export const isDisabledStep = (proposition:IPropositionDetails, step: IInfoStep) => {
    if (step.state === "INACTIVE") {
      return true;
    }

    if (step.category === "PERSONAL" && isConfirmedContactProposition(proposition!)) {
      return true;
    }

    if (hasLockMode(proposition?.stateCode, step.category)) {
        return true;
    }

    if (step.category === "SIGNATURE" && proposition.stateCode === 1) {
        if (step.path === APP_URLS.infoSignatureStep0Page || step.path === APP_URLS.infoSignatureStep1Page || step.path === APP_URLS.infoOldContractPage || step.path === APP_URLS.recapPage) {
            return true;
        }
    }

    return false;
}


  export async function calculOffersRetired(token:string, data: IRERequestDataOffers) {
   
    try {
        const res = await collectOffersRetired(token, data);
        const total = res.data.offers;

        return total;
    } catch (err) {
      return Promise.reject(new Error("Erreur"))
    }
    
}

export async function calculOffers(token:string, data: ISimulateOffers) {
   
    try {
        const res = await collectOffers(token, data);
        const total = res.data;

        return total;
    } catch (err) {
      return Promise.reject(new Error("Erreur"))
    }
    
}

export const getStartPageRetirement = (proposition?: IPropositionDetails, lastStepPath?: string|null, stepCode?:string|null, isConseiller?: boolean): string => {
    if(isPropositionInDraft(proposition!)) {
        if(lastStepPath) {
            return lastStepPath;
        } else return APP_RETIREMENT_URLS.bienvenuePage
        
    } else if (isClosedProposition(proposition!)) {
        return APP_RETIREMENT_URLS.endPage;
    } else if (isDoneProposition(proposition!) && isConseiller && !stepCode) {
        return APP_RETIREMENT_URLS.infoSignatureDonePage;
    } else {
        if(stepCode) {
            const stepPath = ALL_INFO_RETIREMENT_STEPS.find(step => step.code === stepCode)?.path;
            return stepPath??APP_RETIREMENT_URLS.retirementRecapPage;
        }
        return  APP_RETIREMENT_URLS.retirementRecapPage;
    }
}

export const getAdditionalData = (proposition: IPropositionDetails | null): IAdditionalData | null => {
    if (!proposition?.beneficiaries) return null;
    
    const hasPartner = proposition.beneficiaries.some(
        el => el.relationType === relationType.CONCUBIN || el.relationType === relationType.CONJOINT
    );

    const hasChild = proposition.beneficiaries.some(
        el => el.relationType === relationType.CHILD
    );

    if (!hasPartner && !hasChild && !(proposition?.currentStep === "Confirmé" || proposition?.currentStep === "CONFIRME")) {
        return null;
    }
    return { hasPartner, hasChild } as IAdditionalData;
};

export const  isYYYYMM = (str: string) => {
  const regex = /^\d{4}-(0[1-9]|1[0-2])$/;
  return regex.test(str);
}